import React from "react";
import { Link } from "react-router-dom";
import useCart from "hooks/useCart";
import ListView from "components/ListView/ListView";
import CartProductCard from "components/ProductCards/CartProductCard/CartProductCard";
import Button from "components/Button/Button";
import { EmptyCartIcon } from "constants/icons";
import { APP_ROUTES } from "constants/routes";
import { useSelector } from "react-redux";
import { removeDuplicatesFromProductsJson } from "utils/commonMethods";
import "containers/CartOverview/CartProducts/CartProducts.css";

function CartProducts() {
  const { currentCartItems } = useCart();
  const componentTexts = window.appTexts.cart_page;
  const vendingMachineItems = useSelector(
    (state) => state.vmStockReducer.items
  );

  const minifiedVmItems = removeDuplicatesFromProductsJson(
    vendingMachineItems,
    "iUID"
  );

  //concatenate same products together in cart.
  let minifiedCartItems = currentCartItems.map((ele) => ({
    ...ele.item,
    ...ele,
    stk: minifiedVmItems.find((element) => ele.item.iUID === element.iUID).stk, //find concatenated stock of each item
    item: null,
  }));

  //Show no product found icon, if there are no products in cart.
  if (currentCartItems.length === 0) {
    return (
      <div className="cart-footer__empty-cart">
        <div>
          <EmptyCartIcon />
          <p>{componentTexts.empty_cart_text}</p>
          <Link to={APP_ROUTES.HOME_PAGE.url}>
            <Button>{componentTexts.shop_now_button_text}</Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <ListView>
      {removeDuplicatesFromProductsJson(minifiedCartItems, "iUID", false).map(
        (product) => (
          <CartProductCard
            item={product}
            key={product.sid}
            componentTexts={componentTexts}
          />
        )
      )}
    </ListView>
  );
}

export default CartProducts;
